"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { FaHome } from "react-icons/fa";

export default function NotFound() {
  return (
    <section className="min-h-screen flex flex-col justify-center items-center bg-linear-to-br from-[#F9FAFB] via-[#EAF2FB] to-[#D9E8FA] text-center px-6 relative overflow-hidden">
      {/* Background Accent Circles */}
      <div className="absolute top-10 left-10 w-40 h-40 bg-[#4177BC]/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-10 right-10 w-52 h-52 bg-[#EB9C2C]/10 rounded-full blur-3xl"></div>

      {/* AskLocal Logo */}
      <motion.img
        src="/asklocal_logo.svg"
        alt="AskLocal Logo"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-40 sm:w-52 mb-8"
      />

      {/* 404 Number */}
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-[120px] sm:text-[160px] font-bold text-[#4177BC] leading-none drop-shadow-lg"
      >
        404
      </motion.h1>

      {/* Title */}
      <motion.h2
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="text-2xl sm:text-4xl font-semibold text-[#1E1E1E] mt-4"
      >
     This Page Are Not Available 
      </motion.h2>

      {/* Description */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="text-gray-600 mt-4 text-base sm:text-lg max-w-md"
      >
        The page you’re looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </motion.p>

      {/* Button */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5 }}
        className="mt-8"
      >
        <Link
          href="/"
          className="inline-flex items-center gap-2 bg-[#EB9C2C] hover:bg-[#4177BC] text-white font-medium px-8 py-3 rounded-xl shadow-md transition-all duration-300"
        >
          <FaHome className="text-lg" />
          Back to Home
        </Link>
      </motion.div>

      {/* Bottom Decorative Line */}
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "60%" }}
        transition={{ delay: 0.7, duration: 0.8 }}
        className="h-[3px] bg-linear-to-r from-[#4177BC] to-[#EB9C2C] rounded-full mt-12"
      />
    </section>
  );
}
